module.exports = __webpack_public_path__ + "Deploy.35d78df753f0d28f800587e47dabe7d1.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/Deploy.svg
// module id = 6349038924078644
// module chunks = 1